
(function ($, window) {
    "use strict";
   
    let eventListenerAdded = false;

    DSV.ui.subnavigationBar = {

        mobile() {
            const linklists = document.querySelectorAll('.subnavigation-bar__list');

            [...linklists].forEach(linklist => {
                const selectedElement = linklist.querySelector('.selected');

                if(selectedElement) {
                    const offsetLeft = Math.round(selectedElement.offsetLeft - 28);
                    linklist.scrollLeft = offsetLeft;
                } else {
                    linklist.scrollLeft = 28;
                }
            })
        },

        setup() {
            const isMobile = DSV.tools.screenMode.currentMode < DSV.tools.screenSizes.desktop;
            isMobile ? this.mobile() : null;
        },

        resizeHandler() {
            window.addEventListener('resize', () => {
                this.debounce(300, this.setup());
            });   
        },


        debounce(delay, fn) {
            let timerId;
            return function(...args) {
                if (timerId) {
                    clearTimeout(timerId);
                }
                timerId = setTimeout(() => {
                    fn(...args);
                    timerId = null;
                }, delay)
            }
        },

        init() {
            this.setup();
            this.resizeHandler();                 
        },
    };
})(jQuery, window);
